import { EventBus } from '../../../../core/shared/helpers/EventHelper';
import ListComponent from '../../../../core/infraestructure/ListComponent';
import SimulatorQuestionCategoryViewModel from '../../../../core/features/setting/viewmodels/SimulatorQuestionCategoryViewModel';

export default {
  extends: ListComponent,
  data() {
    return {
      modulePermissions: 'Settings-Careers',
      item: null,
      searchName: null,
      searchCode: null,
      viewModel: null,
      parentFilter: '',
      parents: [],
      modalImport: {
        isVisible: false,
        isLoading: false,
        title: 'IMPORTAR CATEGORIAS DE PREGUNTAS',
        onUploadImport: 'onUploadImportSimulatorQuestionCategory',
        onCancelImport: 'onCancelImportSimulatorQuestionCategory',
      },
      filterOptions: {
        status: ''
      },
    };
  },
  mounted() {
    EventBus.$on('onSubmitedSimulatorQuestionCategory', this.onSearch);
    EventBus.$on('onUploadImportSimulatorQuestionCategory', this.onUploadImport);
    EventBus.$on('onCancelImportSimulatorQuestionCategory', this.onCancelImport);
  },
  beforeDestroy() {
    EventBus.$off('onSubmitedSimulatorQuestionCategory', this.onSearch);
    EventBus.$off('onUploadImportSimulatorQuestionCategory', this.onUploadImport);
    EventBus.$off('onCancelImportSimulatorQuestionCategory', this.onCancelImport);
  },
  created() {
    this.viewModel = new SimulatorQuestionCategoryViewModel(this);
    this.onActive();
  },
  methods: {
    onActive() {
      this.onSearch();
    },
    onAllFilterChange(data, field) {
      this.onFilterChange(data, field);
    },
    onShowImport() {
      this.viewModel.showModal(this.modalImport, true);
    },
    onUploadImport(file){
      this.viewModel.showModalLoading(this.modalImport, true);
      this.viewModel.import(file);
    },
    onCancelImport(){
      this.viewModel.showModal(this.modalImport, false);
    },
    onExportToExcel() {
      this.viewModel.exportToExcel();
    },
    onCanCreate() {
      return this.canCreate(this.modulePermissions)
    },
    onCanRead() {
      return this.canRead(this.modulePermissions)
    },
    onCanUpdate() {
      return this.canUpdate(this.modulePermissions)
    },
    onCanDelete() {
      return this.canDelete(this.modulePermissions)
    },
  },
  computed: {}
}